import {Component, Input, OnInit} from '@angular/core';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {Observable} from 'rxjs';
import {map, shareReplay} from 'rxjs/operators';
import {MenuItem} from '../../../interfaces/data.interfaces';
import {SettingsService} from '../../../../services/settings.service';
import {UserTypeEnum} from '../../../interfaces/data.interfaces';
import {StorageService} from '../../../../services/storage-service.service';
import {MenuService} from '../../../../services/menu.service';

@Component({
    selector: 'app-report-layout',
    templateUrl: './report-layout.component.html',
    styleUrls: ['./report-layout.component.scss', '../staff/staff-layout/staff-layout.component.scss'],
    standalone: false
})
export class ReportLayoutComponent implements OnInit{

  mainMenu: MenuItem[];
  @Input() moduleTitle: string;
  @Input() moduleMenu: MenuItem[];
  @Input() moduleIconType: 'SVG' | 'MATERIAL';
  @Input() moduleIconTitle: string;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );
  loggedInUserType: UserTypeEnum;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private settingsService: SettingsService,
    private menuService: MenuService,
    private storageService: StorageService,
  ) {
    this.loggedInUserType = this.storageService.get('category');
  }

  ngOnInit() {
    this.mainMenu = this.menuService.mainMenu;
  }
}
